import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

import "./assets/tailwind.css";

import EvaIcons from "vue-eva-icons";
Vue.use(EvaIcons);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebookF,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faThList,
  faThLarge,
  faAngleLeft,
  faAngleRight,
  faCheck,
  faBullseye,
} from "@fortawesome/free-solid-svg-icons";
import { faGem, faEye } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faFacebookF,
  faInstagram,
  faTwitter,
  faThList,
  faThLarge,
  faAngleLeft,
  faAngleRight,
  faCheck,
  faBullseye,
  faEye,
  faGem
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
